import { isVue3 } from '../vue';
export var getInstanceFromDirective = function getInstanceFromDirective(vnode, bindings) {
  return isVue3 ? bindings.instance : vnode.context;
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/get-instance-from-directive.js
// module id = 65
// module chunks = 0